import React from "react";
import ParagraphTag from "../reusebale/Paragraph";
import LabelTag from "../reusebale/label";
import ButtonTag from '../reusebale/button';
import MyLoader from "../reusebale/myLoader";

const AppealPopup = ({ onReasonSubmit, onBack, onAppealChange, loader }) => {

  return (
    <main className="w-full h-screen backdrop-blur-sm bg-black/80 fixed inset-0 z-50 flex items-center justify-center">
      <section className="w-[90%] sm:w-[65%] md:w-[50%] lg:w-[40%] xl:w-[30%] bg-texture myshades rounded-[31px] mx-auto">
        <div class="bg-white py-8 lg:py-5 rounded-xl justify-center items-center flex flex-col">
          <div>
            <ParagraphTag
              content="Appeal Request"
              classes={`text-darkColor font-popinsSemiBold text-base `}
            />
          </div>
          <div className="pt-2 w-[90%] mx-auto">
            <LabelTag
              isStaric={false}
              name="Appeal Reason"
              classes="!text-xs !font-popinsMedium"
            />
            <textarea
              onChange={onAppealChange}
              type="text"
              cols={10}
              placeholder="Please enter your reason"
              className="w-full h-28 mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
            ></textarea>
          </div>
          <div className="w-full px-2">
            {
              loader ? <div className="flex justify-center items-center mt-2">
                <MyLoader />
              </div> : <> <ButtonTag onSubmit={onReasonSubmit} name='Submit' classes='text-sm bg-themeColor hover:bg-themeColor/90 mt-5 text-center  text-white' />
                <p className="text-darkColor pt-2 flex item-center justify-center cursor-pointer font-popinsMedium text-sm" onClick={onBack}>Close</p></>
            }

          </div>

        </div>
      </section>
    </main>
  );
};

export default AppealPopup;
